import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Pages
import Home from './pages/Home';
import BuyHome from './pages/BuyHome';
import SellHome from './pages/SellHome';
import HomeValuation from './pages/HomeValuation';
import PropertyManagement from './pages/PropertyManagement';
import HoaManagement from './pages/HoaManagement';
import Agents from './pages/Agents';
import AgentPortal from './pages/AgentPortal';
import AgentSignup from './pages/AgentSignup';
import ApplyToJoin from './pages/ApplyToJoin';
import Careers from './pages/Careers';
import AboutUs from './pages/AboutUs';
import Education from './pages/Education';
import NewConstruction from './pages/NewConstruction';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';
import AdminDashboard from './pages/AdminDashboard';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import FAQ from './pages/FAQ';
import Guide from './pages/Guide';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Terms from './pages/Terms';
import AgentWebsite from './pages/AgentWebsite';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import MLSPropertySearch from './pages/MLSPropertySearch';
import MLSPropertyDetail from './pages/MLSPropertyDetail';
import { MemphisTN, SouthavenMS, OliveBranchMS, HernandoMS, ColliervilleTN, GermantownTN } from './pages/CityLandingPages';
import {
  HoaLoginPage, HoaForgotPasswordPage, HoaResetPasswordPage,
  HoaSetPasswordPage, HoaMagicLinkPage, HoaDashboardPage,
} from './pages/HoaPortal';
import { HoaAuthProvider } from './contexts/HoaAuthContext';
import {
  TitleLoginPage, TitleRegisterPage, TitleDashboardPage, TitleNewRequestPage,
  TitleAuthProvider,
} from './pages/TitlePortal';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ProtectedRoute from './components/ProtectedRoute';
import ScrollToTop from './components/ScrollToTop';
import GlobalNova from './components/GlobalNova';
import PropertyGate from './components/PropertyGate';
import Analytics from './components/Analytics';

function App() {
  return (
    <BrowserRouter>
      <HoaAuthProvider>
      <TitleAuthProvider>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/buy" element={<BuyHome />} />
          <Route path="/sell" element={<SellHome />} />
          <Route path="/home-valuation" element={<HomeValuation />} />
          <Route path="/property-management" element={<PropertyManagement />} />
          <Route path="/hoa-management" element={<HoaManagement />} />
          <Route path="/agents" element={<Agents />} />
          <Route path="/education" element={<Education />} />
          <Route path="/new-construction" element={<NewConstruction />} />
          <Route path="/agent-signup" element={<AgentSignup />} />
          <Route path="/agent-portal" element={
            <ProtectedRoute requiredRole="agent">
              <AgentPortal />
            </ProtectedRoute>
          } />
          <Route path="/admin" element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          } />
          <Route path="/admin/analytics" element={
            <ProtectedRoute requiredRole="admin">
              <AnalyticsDashboard />
            </ProtectedRoute>
          } />
          <Route path="/apply" element={<ApplyToJoin />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/guide" element={<Guide />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/agents/:slug" element={<AgentWebsite />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          {/* MLS Property Search - Live Listings */}
          <Route path="/mls" element={<MLSPropertySearch />} />
          <Route path="/mls/:mlsId" element={<MLSPropertyDetail />} />
          
          {/* City Landing Pages */}
          <Route path="/memphis-tn-real-estate" element={<MemphisTN />} />
          <Route path="/southaven-ms-real-estate" element={<SouthavenMS />} />
          <Route path="/olive-branch-ms-real-estate" element={<OliveBranchMS />} />
          <Route path="/hernando-ms-real-estate" element={<HernandoMS />} />
          <Route path="/collierville-tn-real-estate" element={<ColliervilleTN />} />
          <Route path="/germantown-tn-real-estate" element={<GermantownTN />} />

          {/* HOA Homeowner Portal */}
          <Route path="/hoa/login" element={<HoaLoginPage />} />
          <Route path="/hoa/forgot-password" element={<HoaForgotPasswordPage />} />
          <Route path="/hoa/reset-password" element={<HoaResetPasswordPage />} />
          <Route path="/hoa/set-password" element={<HoaSetPasswordPage />} />
          <Route path="/hoa/magic" element={<HoaMagicLinkPage />} />
          <Route path="/hoa/dashboard" element={<HoaDashboardPage />} />

          {/* HOA Title Company Portal — Phase 2 */}
          <Route path="/title/login" element={<TitleLoginPage />} />
          <Route path="/title/register" element={<TitleRegisterPage />} />
          <Route path="/title/dashboard" element={<TitleDashboardPage />} />
          <Route path="/title/request" element={<TitleNewRequestPage />} />
        </Routes>
        <Footer />
        <GlobalNova />
        <PropertyGate />
        <Analytics />
        <Toaster position="top-center" />
      </div>
      </TitleAuthProvider>
      </HoaAuthProvider>
    </BrowserRouter>
  );
}

export default App;
